import { render, staticRenderFns } from "./Fishgroup.vue?vue&type=template&id=7ea6df3a&"
import script from "./Fishgroup.vue?vue&type=script&lang=js&"
export * from "./Fishgroup.vue?vue&type=script&lang=js&"
import style0 from "./Fishgroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports